import { PiralPlugin } from 'piral-core';

import * as actions from './actions';
import { firefliesStorageKey } from './constants';
import { FirefliesApi, FirefliesSettings } from './types';

/**
 * Creates new Pilet API extensions for enabling fireflies effect.
 */
export function createFirefliesApi(): PiralPlugin<FirefliesApi> {
  let settings: FirefliesSettings | null = null;

  const stored = localStorage.getItem(firefliesStorageKey);
  if (stored) {
    settings = JSON.parse(stored);
  }

  return context => {
    context.defineActions(actions);

    context.dispatch(state => ({
      ...state,
      firefliesSettings: settings,
    }));

    return {
      getFirefliesSettings() {
        return context.readState(state => state.firefliesSettings);
      },
    };
  };
}
